import { render, staticRenderFns } from "./OpenApprovals.vue?vue&type=template&id=0e563b94"
import script from "./OpenApprovals.vue?vue&type=script&lang=js"
export * from "./OpenApprovals.vue?vue&type=script&lang=js"
import style0 from "./OpenApprovals.vue?vue&type=style&index=0&id=0e563b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports